import { motion } from 'framer-motion';
import { useEffect, useRef, useState } from "react";
import FeedPost from '../../components/Feed/FeedPost';
import LeftFeedMenu from '../../components/Feed/LeftFeedMenu';
import Header from '../../components/Header';
import Mosaic from '../../components/Mosaic';
import SnipzCarousel from '../../components/SnipzCarousel';
import Stories from "../../components/Stories/StoriesCards";
import StoriesModal from '../../components/Stories/StoriesModal';
import { useTheme } from '../../contexts/theme';
import { api } from '../../services/api';
import { TimeLineDataType } from '../../services/apiTypes';
import { getTimeLine } from '../../utils/apiFunctions';
import {
  Container,
  LeftContainer,
  LeftInnerContainer,
  MasterContainer,
} from './styles';

export default function Feed() {
  const { themeColors } = useTheme();
  const [leftSelected, setLeftSelected] = useState('Feed');
  const [modal, setModal] = useState<boolean>(false);
  const [storiesDisplay, setStoriesDisplay] = useState('flex')
  const [timelineData, setTimeLineData] = useState<TimeLineDataType[]>([])
  const [snipzData, setSnipzData] = useState<TimeLineDataType[]>([])

  useEffect(() => {
    if (leftSelected !== 'Snipz') {
      setStoriesDisplay('flex')
    } else {
      window.scrollTo(0, 0);
    }
  }, [leftSelected]);

  useEffect(() => {
    const getTimelineData = async () => {
      const timeline = await getTimeLine();
      setTimeLineData(timeline);
    }
    getTimelineData();
  }, [])

  useEffect(() => {
    api.get('media/timeline/snipz')
      .then(response => {
        if (response && response.status === 200 && response.data.length > 0) {
          // console.log('snipz', response.data)
          setSnipzData(response.data)
        }
      })
      .catch(error => {
        console.log(error);
      });
  }, [])

  const [sharedPost, setSharedPost] = useState<boolean>(false);
  const [sharePostData, setSharePostData] = useState<TimeLineDataType>();
  useEffect(() => {
    const routeArgs = window.location.pathname.split('/')
    if (routeArgs.length > 1) {
      setSharedPost(true)
      try {
        const postId = routeArgs[1]
        if (!postId) return;
        api.get(`/media/publication/${postId}`)
          .then(response => {
            if (response && response.status === 200) {
              console.log(response.data)
              setSharePostData(response.data)
            }
          })
          .catch(error => {
            console.log(error);
          });
      } catch (error) {
        console.log(error)
      }
    }
  }, [])

  const [initialIndex, setInitialIndex] = useState(0)
  const handleSelectedStory = (i: number) => {
    setModal(true)
    setInitialIndex(i)
  }

  const scrollRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    scrollRef.current?.scrollTo(0, 200);
  }, [leftSelected]);

  return (
    <>
      <Header />
      <MasterContainer
        style={{ backgroundColor: themeColors.background, color: themeColors.textAndButtons }}
        ref={scrollRef}
      >
        {modal && <StoriesModal modal={modal} setModal={setModal} initialIndex={initialIndex} />}
        {/* {true && <FooterModal success={true} text="Conteúdo compartilhado com sucesso!" open={modal} onClose={setModal} />} */}
        <motion.div
          animate={{ height: leftSelected === 'Snipz' ? 0 : 60, opacity: leftSelected === 'Snipz' ? 0 : 1 }}
          onAnimationEnd={() => setStoriesDisplay('none')}
          transition={{ duration: 0.7, ease: [0.04, 0.62, 0.23, 0.98] }}
          style={{
            display: storiesDisplay,
            width: '100%',
            marginTop: storiesDisplay === 'none' ? 0 : 48,
            marginBottom: storiesDisplay === 'none' ? 0 : 48,
            justifyContent: 'center',
            height: storiesDisplay === 'none' ? 0 : '100%'
          }}
        >
          <Stories display={storiesDisplay} modal={modal} setSelectedStory={handleSelectedStory} />
        </motion.div>
        <Container ref={scrollRef}>
          <LeftContainer>
            <LeftInnerContainer>
              <LeftFeedMenu selected={leftSelected} setSelected={setLeftSelected} />
            </LeftInnerContainer>
          </LeftContainer>
          {leftSelected === 'Feed' &&
            <Mosaic
              variant='masonry'
              columns={3}
              type="post"
              gap={0}
              itemData={timelineData}
            />
          }
          {leftSelected === 'Snipz' &&
            <SnipzCarousel
              leftSelected={leftSelected}
              itemData={snipzData}
            />
          }
        </Container>
      </MasterContainer>
      {sharedPost && sharePostData && sharePostData.medias.length > 0 &&
        <FeedPost
          setHidePost={setSharedPost}
          initiateAsModal={true}
          authorAvatarUrl={sharePostData.authorAvatarUrl}
          authorId={sharePostData.authorId}
          authorUsername={sharePostData.authorUsername}
          id={sharePostData.id}
          type={sharePostData.type}
          medias={sharePostData.medias}
          description={sharePostData.description}
          tags={sharePostData.tags}
          likes={sharePostData.likes}
          comments={sharePostData.comments}
          createdAt={sharePostData.createdAt}
          updatedAt={sharePostData.updatedAt}
          isLiked={sharePostData.isLiked}
          feedType='post'
        />}
    </>
  );
}